import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, EventEmitter, inject, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RouterLink } from '@angular/router';
import { FuseCardComponent } from '@fuse/components/card';
import { Helpers } from 'app/core/helpers/helpers';
import { AmountPipe } from 'app/core/pipes/amount.pipe';
import { FinancialService } from '../../../accounting/reports/financial.service';
import { AuthService } from '../../../auth/auth.service';

@Component({
  selector: 'app-recovery-rate',
  standalone: true,
  imports: [RouterLink, FuseCardComponent, AmountPipe, MatProgressSpinnerModule, MatIconModule],
  templateUrl: './recovery-rate.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RecoveryRateComponent implements OnChanges {
  private FinancialReports = inject(FinancialService);
  private auth = inject(AuthService);
  private destroyRef = inject(DestroyRef);
  private cdr = inject(ChangeDetectorRef);

  profile: any;
  dataLoader = false;
  error: string | null = null;
  dataList: any;
  recovery: any;
  totalPayments = 0;
  meta: any;

  @Input() fromDate: any = '';
  @Input() toDate: any = '';
  @Input() associationId: string | null = null;
  @Output() dataLoaded = new EventEmitter<any>();

  constructor() {
    const rang = Helpers.getDateRange('all');
    this.fromDate = rang.from;
    this.toDate = rang.to;
  }

  ngOnChanges(_changes: SimpleChanges) {
    this.dataLoader = true;
    this.profile = this.auth.profile();
    this.getData();
  }

  private getData(): void {
    const filter: any = { from_date: this.fromDate, to_date: this.toDate };
    if (this.associationId) filter.association_id = this.associationId;
    this.meta = null;
    this.dataList = null;
    this.recovery = null;
    this.totalPayments = 0;
    this.dataLoader = true;

    this.FinancialReports.collectionReport(filter)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (data: any) => {
          if (data.status === 'success') {
            this.meta = data.meta;
            this.dataList = data.record;
            this.recovery = data.record.recovery;
            this.totalPayments = data.record.payments || 0;
            this.dataLoaded.emit(data.record);
          } else if (data.status === 'error') {
            this.error = data.error?.message;
          }
          this.dataLoader = false;
          this.cdr.markForCheck();
        },
        error: (error: any) => {
          this.error = error.message;
          this.dataLoader = false;
          this.cdr.markForCheck();
        },
      });
  }
}
